<template>
  <div>
    <div class="item flex-row flex__left margin-bottom-10">
      <div class="label font-size__small txt-right">
        Công văn liên quan
      </div>
      <div class="content width__100"></div>
    </div>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="relationDocs"
        v-if="relationDocs && relationDocs.length"
      >
        <el-table-column width="30">
          <template slot-scope="scope">
            <i
              class="download-icon fas fa-cloud-download-alt clickable"
              @click="downloadFile(scope.row)"
            ></i>
          </template>
        </el-table-column>

        <el-table-column
          label="Trích yếu"
          show-overflow-tooltip
          property="quote"
        >
        </el-table-column>
        <el-table-column
          label="Số ký hiệu"
          width="120"
          show-overflow-tooltip
          property="docCode"
        >
        </el-table-column>
        <el-table-column label="Ngày văn bản" width="125" show-overflow-tooltip>
          <template slot-scope="scope">
            <!--            <i class="el-icon-time"></i>-->
            <span>{{
              scope.row.docDate
                | dateFormatter({
                  dateFormat: "DD/MM/YYYY",
                  nullValue: "-"
                })
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import FileTypeImage from "../../job/FileTypeImage";
import constants from "../../../constants";
import h from "../../../services/h";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import DialogAddDocs from "../../job/create-job/dialog-add-docs";
import HcCommandsAddDocsDialog from "./hc-congviectrongtam-add-docs-dialog";
import hcDocRelationService from "../../../services/hcDocRelationService";
import dateFormatter from "../../../filters/dateFormatter";
import ReadonlyFormItem from "../ketluan/readonly-form-item";
import downloadService from "../../../services/downloadService";

export default {
  name: "hc-commands-doc-relations-readonly",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: {
    ReadonlyFormItem,
    HcCommandsAddDocsDialog,
    DialogAddDocs,
    FileTypeImage
  },
  props: ["objectId", "objectType"],
  filters: { dateFormatter },

  data() {
    return {
      relationDocs: []
    };
  },

  watch: {
    objectId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    reloadData() {
      this.loadRelationDocs().then(hcDocRelations =>
        this.bindToForms(hcDocRelations)
      );
    },

    downloadFile(relationDoc) {
      return downloadService.downloadFileForHcCommandsDocRelation(
        relationDoc.objectId,
        relationDoc.objectType,
        relationDoc.referenceObjectType,
        relationDoc.referenceObjectId
      );
    },

    getSubmitForms() {
      return h.collect(this.relationDocs, relationDoc => {
        return {
          referenceObjectType: relationDoc.referenceObjectType,
          referenceObjectId: relationDoc.referenceObjectId,
          docCode: relationDoc.docCode,
          docDate: relationDoc.docDate ? relationDoc.docDate.getTime() : null,
          quote: relationDoc.quote
        };
      });
    },

    bindToForms(hcDocRelations) {
      this.relationDocs = hcDocRelations;
    },

    loadRelationDocs() {
      switch (this.objectType) {
        case constants.HC_DOC_RELATION.OBJECT_TYPE.HC_CONGVIECTRONGTAM:
          return hcDocRelationService
            .findAllForHcCongViecTrongTam(this.objectId)
            .then(response => response.data);

        case constants.HC_DOC_RELATION.OBJECT_TYPE.HC_CONGVIECTRONGTAM_COMMON:
          return hcDocRelationService
            .findAllForHcCongViecTrongTamCommon(this.objectId)
            .then(response => response.data);

        default:
          return Promise.resolve(null);
      }
    }
  }
};
</script>

<style scoped>
.label {
  width: 185px;
  margin-right: 12px;
  flex: 0 0 auto;
  opacity: 0.75;
}

.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/congviectrongtam/hc-congviectrongtam-doc-relations-readonly.vue